import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Paper, Divider, Typography } from "@mui/material";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.common.grey,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 10,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd),&:nth-of-type(even)": {
        backgroundColor: "#eaf1f8",
    },
    // hide last border
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));

function createData(section, donation, installation, pieces) {
    return { section, donation, installation, pieces };
}

const rows = [
    createData("Artium", "$5,950", "$850", 5),
    createData("Artium Hallway", "$2,250", "$350", 3),
    createData("Conference Room #2", "$1,625", "$250", 3),
];

const CustomDataTable = () => {
    return (
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 350 }} aria-label="customized table">
                <TableHead>
                    <TableRow>
                        <StyledTableCell colSpan={2}>Section</StyledTableCell>
                        <StyledTableCell align="center">Donation</StyledTableCell>
                        <StyledTableCell align="center">Install Cost</StyledTableCell>
                        <StyledTableCell align="center">Pieces</StyledTableCell>
                    </TableRow>
                </TableHead>
                <Divider></Divider>
                <TableBody>
                    {rows.map((row) => (
                        <StyledTableRow key={row.section}>
                            <StyledTableCell component="th" scope="row" colSpan={2}>
                                <strong>{row.section}</strong>
                            </StyledTableCell>
                            <StyledTableCell align="center">{row.donation}</StyledTableCell>
                            <StyledTableCell align="center">{row.installation}</StyledTableCell>
                            <StyledTableCell align="center">{row.pieces}</StyledTableCell>
                        </StyledTableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
export { CustomDataTable };
